import React from 'react';
import PropTypes from 'prop-types';
// import RelatedNews from '../RelatedNews';
// import StrategyTeam from './StrategyTeam';
// import RecentInvestment from '../RecentInvestment';
import style from './InvestmentDetails.module.scss';
import LottieAnimation from '../LottieAnimation';

const InvestmentDetails = props => {
    const { description, title, facts, icons } = props; // Investment type
    // const { title: stitle, items: sitems, cta: scta } = contents[1]; // strategy team
    // const { title: rtitle, items: ritems, cta: rcta } = contents[2]; // Recent Investments
    // const { title, items } = contents[3]; // Related News

    return (
        <>
            <section className={style.el}>
                <div className={[style.container, 'container'].join(' ')}>
                    <div className={style.creditTypeWrapper}>
                        <div className={style.title}>
                            <h1>{title}</h1>
                        </div>
                        <div className={style.desc}>
                            <div
                                dangerouslySetInnerHTML={{
                                    __html: description,
                                }}
                            />
                        </div>
                        <div className={style.iconItemWrapper}>
                            {icons.map(({ text, image, animationJson }, id) => (
                                <div key={id} className={style.iconItem}>
                                    {animationJson ? (
                                        <LottieAnimation json={animationJson} playImmediately={false} />
                                    ) : (
                                        <img src={image.url} alt={image.alt} />
                                    )}
                                    <div
                                        dangerouslySetInnerHTML={{
                                            __html: text,
                                        }}
                                    />
                                </div>
                            ))}
                        </div>

                        <div className={style.facts}>
                            {facts.map(({ title, description }, id) => (
                                <div className={style.factsInfo} key={id}>
                                    <h3 className={style.factsTitle}>{title}</h3>
                                    <div
                                        className={style.factsDesc}
                                        dangerouslySetInnerHTML={{
                                            __html: description,
                                        }}
                                    />
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

InvestmentDetails.propTypes = {
    title: PropTypes.string,
    description: PropTypes.string,
    icons: PropTypes.array,
    facts: PropTypes.array,
};
export default InvestmentDetails;

InvestmentDetails.defaultProps = {};
